import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/Users/xuxun/Documents/projects/xx/antd-utils/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2 {...{
      "id": "getting-started-开始使用"
    }}>{`Getting Started 开始使用`}</h2>
    <ol>
      <li parentName="ol">{`Using npm (Recomended)`}</li>
    </ol>
    <pre><code parentName="pre" {...{
        "className": "language-javascript"
      }}>{`
import AntdUtils from '@antd-utils';
// or 
import { transformTable } from '@antd-utils';

`}</code></pre>
    <ol {...{
      "start": 2
    }}>
      <li parentName="ol">{`Using `}<inlineCode parentName="li">{`<script>`}</inlineCode>{` `}</li>
    </ol>
    <p>{`Direct import using `}<inlineCode parentName="p">{`<script>`}</inlineCode>{`, use `}<inlineCode parentName="p">{`antd-utils.js`}</inlineCode>{` or compressed version `}<inlineCode parentName="p">{`antd-utils-min.js`}</inlineCode>{`, call `}<inlineCode parentName="p">{`window.AntdUtils.xxx`}</inlineCode></p>
    <p>{`浏览器直接引入，使用 `}<inlineCode parentName="p">{`antd-utils.js`}</inlineCode>{` 或者压缩版 `}<inlineCode parentName="p">{`antd-utils-min.js`}</inlineCode>{`，调用 `}<inlineCode parentName="p">{`window.AntdUtils.xxx`}</inlineCode></p>
    <h2 {...{
      "id": "contact"
    }}>{`Contact`}</h2>
    <p>{`Feel free to raise issues and contact me `}</p>
    <p>{`github: `}<a parentName="p" {...{
        "href": "https://github.com/xunge0613"
      }}>{`https://github.com/xunge0613`}</a></p>
    <p>{`weibo: `}<a parentName="p" {...{
        "href": "https://weibo.com/xxdalston"
      }}>{`@徐迅爱上大`}</a></p>
    <p>{`website: `}<a parentName="p" {...{
        "href": "https://xuxun.cool"
      }}>{`清风迅来`}</a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      